import { render, staticRenderFns } from "./ItemsPreviewTable.vue?vue&type=template&id=09f3b8b6&scoped=true&"
import script from "./ItemsPreviewTable.vue?vue&type=script&lang=js&"
export * from "./ItemsPreviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f3b8b6",
  null
  
)

export default component.exports